const activeNotifications = new Map();

function handleDismiss(event) {
	const notification = event.target;
	const key = notification?.dataset?.notificationKey;
	if (key) activeNotifications.delete(key);
	notification?.remove();
}

/**
 * Workbench-backed replacement for the antd notification used by the VIMDT features.
 * Re-using a `key` replaces the notification that is already on screen.
 */
function _notification(params) {
	const {
		title,
		message,
		duration = 60,
		key = `vimdt-${Date.now()}-${Math.random().toString(36).slice(2)}`,
		error = false,
		onClose,
	} = params;

	const host = document.querySelector('wb-notification-host');
	if (!host) {
		console.error('No <wb-notification-host> found; notification dropped.');
		return key;
	}

	activeNotifications.get(key)?.remove();

	const notification = document.createElement('wb-notification');
	notification.dataset.notificationKey = key;
	notification.variant = error ? 'error' : '';
	notification.lifetime = String(duration * 1000);
	notification.innerText = title ? `${title}: ${message}` : message;

	notification.addEventListener('wbdismiss', (event) => {
		handleDismiss(event);
		if (onClose) onClose();
	});

	host.appendChild(notification);
	activeNotifications.set(key, notification);

	return key;
}

export default _notification;
